import { css } from '@emotion/css';

export const copyListStyles = css`
  overflow: auto;
  padding: 0.2em;
  width: 100%;
`;

export const listItemStyles = css`
  margin-bottom: 2px;
`;
